import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import "./i18n";
import { purgeUndefinedLocalStorage } from "@/utils/safeStorage";
import { PostHogProvider } from "@posthog/react";
import { initPosthog } from "@/analytics/posthogClient";

// Sweep any corrupt localStorage entries (values stored as literal
// "undefined" string) BEFORE React mounts so they can't crash the
// app via JSON.parse. One-line defensive boot step.
purgeUndefinedLocalStorage();

// PostHog product analytics — autocapture every click + pageview and
// record sessions for replay. Returns null if no key is configured;
// the conditional render below skips the provider so the app still
// mounts without analytics in unconfigured environments.
const posthog = initPosthog();

// Global handler for broken images - shows placeholder instead of broken image icon
const PLACEHOLDER_IMAGE = 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=400&h=400&fit=crop&auto=format';

window.addEventListener('error', (event) => {
  if (event.target.tagName === 'IMG' && !event.target.dataset.fallbackApplied) {
    event.target.dataset.fallbackApplied = 'true';
    event.target.src = PLACEHOLDER_IMAGE;
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {posthog ? (
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>,
);
